import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/thegrinder/react-handy-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { useAccordion } from '../';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AccordionHeader = makeShortcode("AccordionHeader");
const AccordionSection = makeShortcode("AccordionSection");
const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "useaccordion"
    }}>{`useAccordion`}</h1>
    <p>{`useAccordion is a react hook that returns two prop getters, `}<inlineCode parentName="p">{`getHeaderProps`}</inlineCode>{` and `}<inlineCode parentName="p">{`getSectionProps`}</inlineCode>{`, and an `}<inlineCode parentName="p">{`isActiveSection`}</inlineCode>{` function,
which allow you to build the tabs component you want without forgetting about accessibility.`}</p>
    <h3 {...{
      "id": "getheaderprops"
    }}><strong parentName="h3">{`getHeaderProps`}</strong></h3>
    <p>{`It's a function that takes in a unique id and index, and returns all the props that should be applied to each tab header.
Here is the list of returned props:`}</p>
    <ul>
      <li parentName="ul">{`aria-controls`}</li>
      <li parentName="ul">{`aria-disabled`}</li>
      <li parentName="ul">{`aria-expanded`}</li>
      <li parentName="ul">{`id`}</li>
      <li parentName="ul">{`key`}</li>
      <li parentName="ul">{`onClick`}</li>
      <li parentName="ul">{`onFocus`}</li>
      <li parentName="ul">{`onKeyDown`}</li>
      <li parentName="ul">{`ref`}</li>
    </ul>
    <p>{`If you spread these props over a custom component, make sure to properly pass down ref (typically, using `}<inlineCode parentName="p">{`React.forwardRef`}</inlineCode>{`).`}</p>
    <h3 {...{
      "id": "getsectionprops"
    }}><strong parentName="h3">{`getSectionProps`}</strong></h3>
    <p>{`It's a function that takes in a unique id and index, and returns all the props that should be applied to each tab header.
Here is the list of returned props:`}</p>
    <ul>
      <li parentName="ul">{`aria-hidden`}</li>
      <li parentName="ul">{`aria-labelledby`}</li>
      <li parentName="ul">{`id`}</li>
      <li parentName="ul">{`key`}</li>
      <li parentName="ul">{`role`}</li>
      <li parentName="ul">{`style`}</li>
      <li parentName="ul">{`ref`}</li>
    </ul>
    <p>{`If you spread these props over a custom component, make sure to properly pass down ref (typically, using `}<inlineCode parentName="p">{`React.forwardRef`}</inlineCode>{`).`}</p>
    <h3 {...{
      "id": "isactivesection"
    }}><strong parentName="h3">{`isActiveSection`}</strong></h3>
    <p>{`It's a simple function that takes in an index of the tab header/section and returns true or false depending whether it's an active one or not.`}</p>

    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <Playground __position={0} __code={'() => {\n  const AccordionHeader = React.forwardRef((props, ref) => (\n    <button {...props} style={{ fontSize: \'16px\' }}>\n      {props.isOpen ? \'close\' : \'open\'}\n    </button>\n  ))\n  const AccordionSection = React.forwardRef((props, ref) => (\n    <div {...props}>\n      <div ref={ref}>{props.children}</div>\n    </div>\n  ))\n  const Example = () => {\n    const {\n      getHeaderProps,\n      getSectionProps,\n      isActiveSection,\n    } = useAccordion()\n    const items = [\n      {\n        id: \'one\',\n        section: \'section one\',\n      },\n      {\n        id: \'two\',\n        section: \'section two\',\n      },\n    ]\n    return (\n      <div aria-label=\"accordion example\">\n        {items.map(({ id, section }, index) => (\n          <div key={id}>\n            <AccordionHeader\n              isOpen={isActiveSection(index)}\n              {...getHeaderProps(id, index)}\n            />\n            <AccordionSection {...getSectionProps(id, index)}>\n              {section}\n            </AccordionSection>\n          </div>\n        ))}\n      </div>\n    )\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useAccordion,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const AccordionHeader = React.forwardRef((props, ref) => <button {...props} style={{
          fontSize: '16px'
        }}>
        {props.isOpen ? 'close' : 'open'}
      </button>);
        const AccordionSection = React.forwardRef((props, ref) => <div {...props}>
        <div ref={ref}>{props.children}</div>
      </div>);

        const Example = () => {
          const {
            getHeaderProps,
            getSectionProps,
            isActiveSection
          } = useAccordion();
          const items = [{
            id: 'one',
            section: 'section one'
          }, {
            id: 'two',
            section: 'section two'
          }];
          return <div aria-label="accordion example">
          {items.map(({
              id,
              section
            }, index) => <div key={id}>
              <AccordionHeader isOpen={isActiveSection(index)} {...getHeaderProps(id, index)} mdxType="AccordionHeader" />
              <AccordionSection {...getSectionProps(id, index)} mdxType="AccordionSection">
                {section}
              </AccordionSection>
            </div>)}
        </div>;
        };

        return <Example mdxType="Example" />;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      